import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=ffe60498&scoped=true"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"
import style0 from "./updatePassword.vue?vue&type=style&index=0&id=ffe60498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe60498",
  null
  
)

export default component.exports